import axios from 'axios'

const host = document.location.host;
let prodUrl = 'musicmanager.storever.com';
let prodUrlQa = 'musicmanager-qa.mcubedigital.com';
let stagingUrl = 'musicmanager.staging.mcubedigital.local';
let endpoint = {};
if ('musicmanager.staging.mcubedigital.local' === host || 'musicmanager.mcubedigital.com' === host) {
 endpoint = {
    //fouwe:          'http://localhost:41344/',
    fouwe:         'https://musicmanagerapi.staging.mcubedigital.local',
    development:    'http://localhost:41344/',
    staging:        'https://musicmanagerapi.staging.mcubedigital.local',
    production:     'https://musicmanager-api.mcubedigital.com/'
};
    prodUrl = 'musicmanager.mcubedigital.com';
    stagingUrl = 'musicmanager.staging.mcubedigital.local';
} else if ( 'musicmanager-qa.mcubedigital.com' === host) {
    endpoint = {
       // fouwe:          'http://localhost:41344/',
         fouwe:         'https://musicmanagerapi.staging.mcubedigital.local',
        development:    'http://localhost:41344/',
        staging:        'https://musicmanagerapi.staging.mcubedigital.local',
        production:     'https://musicmanager-api-qa.mcubedigital.com/'
    };
    prodUrl = 'musicmanager.mcubedigital.com';
    stagingUrl = 'musicmanager.staging.mcubedigital.local';
} else {
    endpoint = {
        // fouwe:          'http://localhost:41344/',
        fouwe:          'https://musicmanagerapi.staging.mcubedigital.local',
        development:    'http://localhost:41344/',
        staging:        'http://musicmanager-api-staging.storever.com/',
        production:     'http://musicmanager-api.storever.com/'
    };
    
}

// quick fix to handle api according context



const urlAPI = (host === prodUrl || host === prodUrlQa) ? endpoint.production : (host === stagingUrl ? endpoint.staging : endpoint.fouwe);
const source = axios.CancelToken.source();
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
export const HTTP = axios.create({
    baseURL: urlAPI,
    cancelToken: source.token,
    withCredentials: true
});
